var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{},[_c('ele-calendar',{ref:"calendarRef",attrs:{"render-content":_vm.renderContent,"data":_vm.data,"prop":_vm.prop,"currentmonth":true,"disabledDate":_vm.disabledDate},on:{"pick":_vm.pick,"date-change":_vm.dateChange,"select":_vm.selectEvent}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }